export default "__VITE_ASSET__DinQN$$Z__"